var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'has-error': _vm.hasErrors,
    'disabled': _vm.disabled,
  }},[_c('el-radio',{attrs:{"value":_vm.value,"name":_vm.name,"disabled":_vm.disabled,"label":_vm.label,"required":_vm.required},on:{"change":_vm.onChange}},[_vm._t("default",function(){return [_vm._v("{name}")]}),_vm._v(_vm._s(_vm.required ? ' *' : '')+"\n  ")],2),_vm._v(" "),(_vm.hasErrors)?_c('div',{staticClass:"form-group__errors"},[_c('p',[_vm._v(_vm._s(_vm.errors[0]))])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }